import { Injectable } from '@angular/core';
import {
    AbstractFindOneByAttributeService
} from "../../../../core/service/v2/service/findone/abstractFindOneByAttribute.service";
import {DocumentModel} from "../model/document.model";
import {DocumentRepository} from "../../impl/service/ngrx/document.repository";
import {DocumentDataServiceAdapter} from "../../impl/service/ngrx/documentDataService.adapter";


@Injectable()
export class DocumentFindOneByPublicIdService extends AbstractFindOneByAttributeService<DocumentModel, DocumentModel> {

    constructor(repository: DocumentRepository,
                dataServiceAdapter: DocumentDataServiceAdapter) {
        super(repository, dataServiceAdapter);
    }

    protected getAttributeName(): string {
        return 'publicId';
    }
}
